module.exports = __webpack_public_path__ + "img/advantages-icon2.6fa1ff0c.png";